import React, { ReactElement } from 'react'
import { QuantifiedIngredient } from '@mindfulchefuk/features/Recipes/interfaces'
import { Box, IText, Text } from '@mindfulchefuk/design-system'
import { RecipeIngredient } from '@mindfulchefuk/features/Recipes/components/RecipeIngredients/RecipeIngredient'

type TRecipeIngredients = {
  quantifiedIngredients: Pick<
    QuantifiedIngredient,
    'id' | 'displayTitle' | 'description' | 'allergens' | 'possibleAllergens'
  >[]
  textVariant: IText['variant']
}

export const RecipeIngredients = ({
  quantifiedIngredients,
  textVariant,
}: TRecipeIngredients): ReactElement =>
  quantifiedIngredients.length > 0 && (
    <Box as="ul">
      {quantifiedIngredients.map(
        ({ id, displayTitle, description, allergens, possibleAllergens }) => (
          <Text as="li" key={id} variant={textVariant}>
            <RecipeIngredient
              displayTitle={displayTitle}
              description={description}
              allergens={allergens}
              possibleAllergens={possibleAllergens}
            />
          </Text>
        )
      )}
    </Box>
  )
